module.exports = __webpack_public_path__ + "img/companyleft.4d3af0ee.png";